import React from "react";
import ReactDOM from "react-dom";
import "./assets/main.css";
import App from "./App";

const mountableElements = [
  document.getElementById("gw-search"),
  ...Array.from(document.querySelectorAll(".gw-search"))
].filter(m => m);

mountableElements.map(m => ReactDOM.render(<App children={m.innerHTML} />, m));
